import NavItem from './NavItem';
import MenuLinks from './config';
import PropTypes from 'prop-types';
import Logo from 'src/components/Logo';
import useAuth from 'src/hooks/useAuth';
import React, { useEffect, useState } from 'react';
import MyAvatar from 'src/components/MyAvatar';
import Scrollbars from 'src/components/Scrollbars';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { Link as RouterLink, useLocation, matchPath } from 'react-router-dom';
import { alpha, makeStyles } from '@material-ui/core/styles';
import {
  Box,
  List,
  Button,
  Drawer,
  Hidden,
  Typography,
  ListSubheader,
  Avatar
} from '@material-ui/core';
import firebase from 'firebase';
import { getCountBadgeActionForDistributor } from 'src/api/badgeAction';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const domainURL = process.env.REACT_APP_DOMAIN;

const useStyles = makeStyles((theme) => {
  const isLight = theme.palette.mode === 'light';

  return {
    drawer: {
      [theme.breakpoints.up('lg')]: {
        flexShrink: 0,
        width: DRAWER_WIDTH
      }
    },
    drawerPaper: {
      width: DRAWER_WIDTH,
      background: theme.palette.background.default
    },
    subHeader: {
      ...theme.typography.overline,
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(5),
      color: theme.palette.text.primary
    },
    account: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2, 2.5),
      margin: theme.spacing(1, 2.5, 5),
      borderRadius: theme.shape.borderRadiusSm,
      background: theme.palette.grey[isLight ? 200 : 800],
      // cursor: 'pointer'
    },
    doc: {
      padding: theme.spacing(2.5),
      borderRadius: theme.shape.borderRadiusMd,
      backgroundColor: isLight
        ? alpha(theme.palette.primary.main, 0.08)
        : theme.palette.primary.lighter
    }
  };
});

// ----------------------------------------------------------------------

function reduceChild({ array, item, pathname, level, listBadgeAction }) {
  const key = item.href + level;

  const badgeContentFormat = item?.badgeModule && listBadgeAction[item?.badgeModule] 
      ? listBadgeAction[item?.badgeModule] 
      : '';

  if (item.items) {
    const match = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    array = [
      ...array,
      <NavItem
        key={key}
        level={level}
        icon={item.icon}
        info={item.info}
        href={item.href}
        title={item.title}
        badgeModule={item.badgeModule}
        badgeContent={badgeContentFormat}
        open={Boolean(match)}
      >
        {renderNavItems({
          pathname,
          level: level + 1,
          items: item.items,
          listBadgeAction: listBadgeAction
        })}
      </NavItem>
    ];
  } else {
    array = [
      ...array,
      <NavItem
        key={key}
        level={level}
        href={item.href}
        icon={item.icon}
        info={item.info}
        title={item.title}
        badgeModule={item.badgeModule}
        badgeContent={badgeContentFormat}
      />
    ];
  }
  return array;
}

function renderNavItems({ items, pathname, level = 0, listBadgeAction }) {
  return (
    <List disablePadding>
      {items.reduce(
        (array, item) => reduceChild({ array, item, pathname, level, listBadgeAction }),
        []
      )}
    </List>
  );
}

NavBar.propTypes = {
  onCloseNav: PropTypes.func,
  isOpenNav: PropTypes.bool
};

function NavBar({ isOpenNav, onCloseNav }) {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const firebaseUser = firebase.auth().currentUser;

  const [modifiedMenuLinks, setModifiedMenuLinks] = useState([])

  const [listBadgeAction, setListBadgeAction] = useState({})

  useEffect(async () => {
    if (isOpenNav && onCloseNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
   
    console.log('USER: ', user)
    
    let distributorAccessList = []
    let distributorAccessMode = ''
    distributorAccessList = user.accessItem
    distributorAccessMode = user.accessPreferencesSetting

    let userAccessList = []
    userAccessList = user.general_access_list

    const token = await firebaseUser.getIdToken();
    const result = await getCountBadgeActionForDistributor(token, {
      userID: user._id,
      distributorID: user.distributorID
    })

    setListBadgeAction(result)

    if (distributorAccessMode === "default") {
      // MEANS ALL ALLOWED BY ADMIN KC, THEN CHECK INDIVIDUAL USER ACCESS
      const modifiedMenuLinksList = MenuLinks.map((obj) => ({
        ...obj,
        items: obj.items.filter((item) => userAccessList.includes(item.access) || item.access === "general" || (item.access === "subdistributor" && user.hasSubDistributorPortalAccess && !_.isEmpty(user.parentDistributors)))
      }))
  
      let finModified = []
      for (const item of modifiedMenuLinksList) {
        if (item.items.length > 0) {
          console.log('ITEM: ', item)
          finModified.push(item);
        }        
      }
  
      setModifiedMenuLinks(finModified)
    }
    else {
      const modifiedMenuLinksList = MenuLinks.map((obj) => ({
        ...obj,
        items: obj.items.filter((item) => (userAccessList.includes(item.access) && distributorAccessList.includes(item.distributorAccess)) || item.access === "general" || (item.access === "subdistributor" && user.hasSubDistributorPortalAccess && !_.isEmpty(user.parentDistributors)))
      }))
  
      let finModified = []
      for (const item of modifiedMenuLinksList) {
        if (item.items.length > 0) {
          finModified.push(item);
        }        
      }
  
      setModifiedMenuLinks(finModified)
    }
    

  }, [pathname, user]);

  const renderContent = (
    <Scrollbars>
      <Box sx={{ px: 2.5, py: 3 }}>
        {/**<RouterLink to="/admin/dashboard">
          <Logo />
        </RouterLink>*/}
        <Logo/>
      </Box>

      <div 
        className={classes.account}
      >
        <div style={{ cursor: 'pointer' }}>
          {
            _.isEmpty(user?.photoUrl) ? (
              <MyAvatar 
                onClick={() => {
                  window.location.href = `${domainURL}/module/profile`
                }}
              />
            )
            :
            (
              <Avatar
                alt={user.firstName}
                src={user?.photoUrl}
                onClick={() => {
                  window.location.href = `${domainURL}/module/profile`
                }}
              />
            )
          }
        </div>
        
        <Box sx={{ ml: 2 }}>
          <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
            {user.firstName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {user.role}
          </Typography>
          <Typography 
            onClick={() => {
              window.location.href = `${domainURL}/module/company-account`
            }}
            variant="body2" sx={{ color: 'text.secondary', maxWidth: '125px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', cursor: 'pointer' }}>
            {user.companyName}
          </Typography>
        </Box>
      </div>
      
      {modifiedMenuLinks.map((list, index) => (
        <List
          disablePadding
          key={index}
          subheader={
            <ListSubheader
              disableSticky
              disableGutters
              className={classes.subHeader}
            >
              {list.subheader}
            </ListSubheader>
          }
        >
          {renderNavItems({
            items: list.items,
            pathname: pathname,
            listBadgeAction: listBadgeAction
          })}
        </List>
      ))}
    </Scrollbars>
  );

  return (
    <nav className={classes.drawer}>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={isOpenNav}
          variant="temporary"
          onClose={onCloseNav}
          classes={{ paper: classes.drawerPaper }}
        >
          {renderContent}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          open
          anchor="left"
          variant="persistent"
          classes={{ paper: classes.drawerPaper }}
        >
          {renderContent}
        </Drawer>
      </Hidden>
    </nav>
  );
}

export default NavBar;
